import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PopupWindowService {
  public popupWindowState = new BehaviorSubject<any>({

    isOpen: false,
    componentName: undefined,
    componentViewModel: undefined,
    isOpenFromOnboarding: false,
  });

  public businessServices : any;

  popupWindowState$ = this.popupWindowState.asObservable();

  public popupWindowData = new Subject();
  popupWindowData$ = this.popupWindowData.asObservable();
}
